"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransitionBox = exports.Fader = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var react_transition_group_1 = require("react-transition-group");
var useFaderTimer_1 = require("./useFaderTimer");
var transitionDuration = 500; // must match transition speed in css
var Fader = function (props) {
    var speed = props.speed, itemsToShow = props.itemsToShow, children = props.children;
    var _a = (0, useFaderTimer_1.useFaderTimer)({ speed: speed, itemsToShow: itemsToShow, children: children, transitionDuration: transitionDuration }), animation = _a.animation, visibleItems = _a.visibleItems;
    return (react_1.default.createElement(react_transition_group_1.CSSTransition, { in: animation, classNames: "fader", timeout: transitionDuration },
        react_1.default.createElement(exports.TransitionBox, null, visibleItems)));
};
exports.Fader = Fader;
exports.TransitionBox = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &.fader-enter {\n    opacity: 0.01;\n  }\n\n  &.fader-enter-active {\n    opacity: 1;\n    transition: opacity 800ms ease-out;\n  }\n\n  &.fader-exit {\n    opacity: 1;\n  }\n\n  &.fader-exit-active {\n    opacity: 0.01;\n    transition: opacity ", "ms ease-in;\n  }\n"], ["\n  &.fader-enter {\n    opacity: 0.01;\n  }\n\n  &.fader-enter-active {\n    opacity: 1;\n    transition: opacity 800ms ease-out;\n  }\n\n  &.fader-exit {\n    opacity: 1;\n  }\n\n  &.fader-exit-active {\n    opacity: 0.01;\n    transition: opacity ", "ms ease-in;\n  }\n"])), transitionDuration);
exports.default = exports.Fader;
var templateObject_1;
